import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrThickArrowDownIconComponent: TemplateOnlyComponent<Signature> =
  <template>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      class={{@class}}
      ...attributes
    >
      <path
        d='M14.8485 4.15122C14.3798 3.68262 13.6201 3.68267 13.1515 4.15133L8.00073 9.3027L2.84931 4.15128C2.38068 3.68265 1.62088 3.68265 1.15225 4.15128C0.683624 4.61991 0.683624 5.3797 1.15225 5.84833L7.15225 11.8483C7.3773 12.0734 7.68254 12.1998 8.00082 12.1998C8.31909 12.1998 8.62432 12.0733 8.84936 11.8483L14.8486 5.84828C15.3172 5.37962 15.3172 4.61982 14.8485 4.15122Z'
        fill='currentColor'
      />
    </svg>
  </template>;

export default WrThickArrowDownIconComponent;
